import { AbstractHttp, ServiceMethod } from '@app/libs/services';

export class NewsService extends AbstractHttp {
  protected services = {
    list: {
      uri: '/portal/news',
      method: 'GET' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        keyword: { required: false },
        address: { required: false },
        types: { required: false },
        bedRoom: { required: false },
        bathRoom: { required: false },
        fromPrice: { required: false },
        toPrice: { required: false },
        fromArea: { required: false },
        toArea: { required: false },
        orientation: { required: false },
        furnitureType: { required: false },
        pageIndex: { required: false },
        pageSize: { required: false },
        provinceCodes: { required: false },
        wardCodes: { required: false },
        lat: { required: false },
        lng: { required: false },
        distance: { required: false },
        orderBy: { required: false },
        idIgnore: { required: false },
      },
    },
    detail: {
      uri: '/portal/news/{id}',
      method: 'GET' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
      params: {
        id: { required: true },
      },
    },
    statistic: {
      uri: '/portal/news/statistic',
      method: 'GET' as ServiceMethod,
      host: '/',
      prefix: 'api',
      version: 'v1',
    },
  };

  list({
    keyword,
    address,
    types,
    bedRoom,
    bathRoom,
    fromPrice,
    toPrice,
    fromArea,
    toArea,
    orientation,
    furnitureType,
    provinceCodes,
    wardCodes,
    pageIndex = 1,
    pageSize = 12,
    lat,
    lng,
    distance,
    orderBy,
    idIgnore,
  }: any) {
    return this.send('list', {
      params: {
        keyword,
        address,
        types,
        bedRoom,
        bathRoom,
        fromPrice,
        toPrice,
        fromArea,
        toArea,
        orientation,
        furnitureType,
        pageIndex,
        pageSize,
        provinceCodes,
        wardCodes,
        lat,
        lng,
        distance,
        orderBy,
        idIgnore,
      },
    });
  }

  statistic() {
    return this.send('statistic', {});
  }

  detail(id: string) {
    return this.send('detail', { params: { id } });
  }
}

export const newsService = new NewsService();
